var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.useNewView)?_c('contracts-shell',{on:{"legacy":_vm.openLegacy}}):_c('contracts-legacy',{on:{"new-view":_vm.openNewView}})
}
var staticRenderFns = []

export { render, staticRenderFns }